// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3slQ0","info":"UpdateTermsInfo_info__6UWAb"};